import React, { useRef, useState } from 'react';
import VolumeOverCapacityDialog from '../VolumeOverCapacityDialog';
import volumeOverCapacity from '../utils/volumeOverCapacity';

// Confirmation asked before recording a volume above the container's capacity.
// confirmVolume resolves true when there is nothing to confirm or the operator
// forces it; on cancel it resolves false and focuses the volume to correct it.
// volumeInputRef goes on the volume NumberInput as inputRef (passed to the TextField
// input; getInputRef would get the TextField root).
export default function useVolumeOverCapacityConfirm({ fillingStatus, liquidVolumeHidden }) {
  const [request, setRequest] = useState(null);
  const volumeInputRef = useRef(null);

  const confirmVolume = (values) => {
    const issue = volumeOverCapacity(values, { fillingStatus, liquidVolumeHidden });
    if (!issue) return Promise.resolve(true);
    return new Promise((resolve) => {
      setRequest({ issue, resolve });
    });
  };

  const close = (forced) => {
    request.resolve(forced);
    setRequest(null);
    if (!forced) {
      setTimeout(() => {
        const input = volumeInputRef.current;
        if (input) {
          input.focus();
          input.select();
        }
      }, 0);
    }
  };

  const dialog = (
    <VolumeOverCapacityDialog
      issue={request?.issue}
      onCancel={() => close(false)}
      onForce={() => close(true)}
    />
  );

  return { confirmVolume, dialog, volumeInputRef };
}
